import React, {useState} from 'react';
import {Button, message} from 'antd';
import {HttpService} from "../../services/http/Http.service";
import {SimulatorPersonIdPair} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";
import ConfirmModal from "../confirmModal/ConfirmModal";

interface PracticeSendNotifyProps {
    title?: string;
    selectedSimulatorPersonPairs: SimulatorPersonIdPair[];
    onSuccess: () => void;
}

const PracticeSendNotify: React.FC<PracticeSendNotifyProps> = ({ title, selectedSimulatorPersonPairs, onSuccess}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        if (selectedSimulatorPersonPairs.length > 0) {
            setIsModalOpen(true);
        } else {
            message.error("Nessun utente selezionato.");
        }
    };

    const [onNotifyLoading, setOnNotifyLoading] = useState(false);

    const handleConfirm = async () => {
        setOnNotifyLoading(true);
        try {
            await HttpService.getInstanceAxios().post(
                `/file-ts/send-notify`,
                selectedSimulatorPersonPairs
            );

            message.success("Pratiche messe in coda per l'invio a SEND");
            setIsModalOpen(false);
            onSuccess();
        } catch (error) {
            HttpErrorService.handle("Errore durante l'operazione", error, true);
        } finally {
            setOnNotifyLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={openModal}
                size={"large"}
                disabled={selectedSimulatorPersonPairs.length === 0}
                type={"default"}>
                {title ?? 'Notifica con SEND'}
            </Button>
            <ConfirmModal
                visible={isModalOpen}
                onConfirm={handleConfirm}
                onCancel={() => setIsModalOpen(false)}
                title="Notifica con SEND"
                loading={onNotifyLoading}
            />
        </>
    );
};

export default PracticeSendNotify;
